// @flow

import { withProps } from 'recompose';
import ENV from '../env';

/**
 * If embedded mode is enabled call map function
 */
export default function withEmbeddedMode(map: (props: Object) => Object) {
  return withProps(props => {
    try {
      const embeddedMode = JSON.parse(ENV.PUSHBOT_EMBEDDED_MODE);
      return embeddedMode ? map(props) : props;
    } catch (e) {
      return props;
    }
  });
}



// WEBPACK FOOTER //
// ./js/util/withEmbeddedMode.js